import { handleActions } from 'redux-actions'
import { setLastAttachedForm, closeSwitchFormDialog, resetFormsState } from '../actions'

const defaultValue: {
  isAttachedFromCondition: boolean
  formId?: number
} = {
  isAttachedFromCondition: false,
  formId: undefined,
}

const lastAttachedForm = handleActions(
  {
    [setLastAttachedForm.toString()](state, action) {
      return action.payload
    },
    [closeSwitchFormDialog.toString()](state, action) {
      return defaultValue
    },
    [resetFormsState.toString()](state, action) {
      return defaultValue
    },
  },
  defaultValue
)

export default lastAttachedForm
